import {
    Group,
    InviteUsersRequest,
    InviteUsersResponse,
    User,
    UserRole,
} from "../../types/UserGroup";
import { SpendCategory } from "../../types/VendorTypes";
import { safeGET, safePOST, safePUT } from "./SafeClient";

export function getMe(abort?: any): Promise<User> {
    return safeGET("/api/user/me", abort);
}

export function getUsers(userIds: number[], abort?: any): Promise<User[]> {
    const idq = userIds.map((v) => `userId[]=${v}`).join("&");
    return safeGET(`/api/user/m?${idq}`, abort);
}

export function listUsers(abort?: any): Promise<User[]> {
    return safeGET(`/api/user`, abort);
}
export function getGroups(groupIds: number[], abort?: any): Promise<Group[]> {
    const idq = groupIds.map((v) => `groupId[]=${v}`).join("&");
    return safeGET(`/api/group/m?${idq}`, abort);
}

export function loadUserGroupSuggestion(
    match: string,
    type: "u" | "g" | "ug",
    abort?: any
): Promise<any> {
    return safeGET(`/api/ug/s?q=${match}&t=${type}`, abort);
}

export function updateUser(user: User): Promise<User> {
    return safePUT(`/api/user/${user.id}`, user);
}

export function getOrganization(abort?: any): Promise<any> {
    return safeGET(`/api/org`, abort);
}

/** The org's own project category taxonomy; `categories` is null when it has none. */
export function getCategories(abort?: any): Promise<{ categories: SpendCategory[] | null }> {
    return safeGET(`/api/org/categories`, abort);
}

// Membership management, for the org's admins.

export function inviteUsers(request: InviteUsersRequest): Promise<InviteUsersResponse> {
    return safePOST("/api/user/invite", request);
}

export function resendInvitation(userId: number): Promise<User> {
    return safePOST(`/api/user/${userId}/resend-invite`, undefined);
}

export function deactivateUser(userId: number): Promise<User> {
    return safePOST(`/api/user/${userId}/deactivate`, undefined);
}

export function reactivateUser(userId: number): Promise<User> {
    return safePOST(`/api/user/${userId}/reactivate`, undefined);
}

export function setUserRoles(userId: number, roles: UserRole[]): Promise<User> {
    return safePUT(`/api/user/${userId}/roles`, { roles });
}
